import { SVGProps, Ref, forwardRef } from 'react';

export const ViberBrandSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M19.97 3.02c-.531-.483-2.826-1.924-7.614-1.945 0 0-5.67-.373-8.423 2.12-1.532 1.513-2.048 3.762-2.105 6.507s-.35 7.988 4.671 9.383l-.022 4.235c0 .24.038.403.175.437.098.024.246-.027.371-.152.803-.806 3.373-3.907 3.373-3.907 3.448.225 6.192-.456 6.487-.552.696-.224 4.459-.547 5.096-5.691.658-5.303-.242-8.922-2.009-10.434"
                fill="#7360F2"
            />
            <path
                d="M14.79 9.476q-.093-1.883-1.913-1.978"
                stroke="white"
                strokeWidth={0.64}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M16.433 10.027q.038-1.755-1.04-2.932c-.721-.787-1.72-1.221-3.001-1.315"
                stroke="white"
                strokeWidth={0.64}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M18.114 10.685q-.023-3.044-1.82-4.796-1.796-1.75-4.467-1.77"
                stroke="white"
                strokeWidth={0.64}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12.94 13.764s.45.038.693-.26l.472-.595c.228-.294.778-.482 1.316-.182q.607.345 1.174.75c.358.262 1.09.873 1.092.873.348.294.429.726.191 1.182l-.002.01a5 5 0 0 1-.983 1.21c-.004.002-.004.005-.008.007q-.51.425-.999.482a1.328 1.328 0 0 1-.57-.056l-.01-.015c-.504-.142-1.345-.498-2.745-1.27a16.4 16.4 0 0 1-2.306-1.523 12 12 0 0 1-1.037-.92l-.035-.035-.035-.035-.035-.035-.035-.035a12 12 0 0 1-.92-1.037 16.4 16.4 0 0 1-1.523-2.305c-.772-1.401-1.128-2.241-1.27-2.745l-.015-.01a1.3 1.3 0 0 1-.065-.425.6.6 0 0 1 .008-.146q.061-.49.484-1c.002-.004.004-.004.007-.008.348-.39.757-.722 1.21-.983l.01-.002c.455-.238.888-.157 1.182.19.002.002.611.734.873 1.091q.405.569.75 1.175c.3.538.112 1.09-.183 1.316l-.594.473c-.3.242-.26.692-.26.692s.88 3.332 4.169 4.171"
                fill="white"
            />
        </g>
    </svg>
));
ViberBrandSize24Glyph.displayName = 'ViberBrandSize24Glyph';
